export default "__VITE_ASSET__6yz0YN0p__"